// extracted by mini-css-extract-plugin
export default {"addMessageInput":"add-message-addMessageInput-aW868q","add":"add-message-add-kWnlzv"};